import { render, staticRenderFns } from "./P006.vue?vue&type=template&id=53631c40"
import script from "./P006.vue?vue&type=script&lang=js"
export * from "./P006.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports